var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6361 39.2748C30.4814 39.2748 39.2732 30.4829 39.2732 19.6376C39.2732 8.7922 30.4814 0.000305176 19.6361 0.000305176C8.79086 0.000305176 -0.000976562 8.7922 -0.000976562 19.6376C-0.000976562 30.4829 8.79086 39.2748 19.6361 39.2748Z",
    fill: "#2CA2E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9713 28.3493C14.6382 29.0899 13 28.1259 13 26.601V13.399C13 11.8741 14.6382 10.9101 15.9713 11.6507L27.853 18.2517C29.2247 19.0137 29.2247 20.9863 27.853 21.7483L15.9713 28.3493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.b4cf5d39a1f3dadc078dfb096fb4464b.svg";
export { ForwardRef as ReactComponent };